export const DETAIL_PAGE_IMAGE_GALLERY_CLICKED = 'DETAIL_PAGE_IMAGE_GALLERY_CLICKED';
export const DETAIL_PAGE_IMAGE_GALLERY_CLICKED_VERSION = '1.0';

export type DetailPageImageGalleryClickedPayload = {
  searchId: string;
  productDetailKey: string;
};

export type DetailPageImageGalleryClickedParams = {
  searchId: string;
  productDetailKey: string;
};

export const createDetailPageImageGalleryClickedPayload = ({
  searchId,
  productDetailKey,
}: DetailPageImageGalleryClickedParams): DetailPageImageGalleryClickedPayload => ({
  searchId,
  productDetailKey,
});
